import { useTranslation } from "react-i18next";
import { useContext, useEffect, useState } from "react";
import { confirmAlert } from "react-confirm-alert";
import {
  HelperDialog, TrueffortButton, TrueffortChip, TrueffortConfirmAlert,
  TrueffortTextField
} from "../../MUIstyle/MUICustom";
import {
  Chip, Collapse, Grid, IconButton, ListItemIcon, ListItemText, Menu, MenuItem,
  Paper, Select as MaterialSelect, Stack, SvgIcon, TextField, Tooltip, Typography
} from "@mui/material";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import ErrorIcon from "@mui/icons-material/Error";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFolderTree } from "@fortawesome/free-solid-svg-icons/faFolderTree";
import {
  Pending as PendingIcon, Add as AddIcon, SquareFoot as SquareFootIcon, Delete as DeleteIcon, Check as CheckIcon,
  Cancel as CancelIcon
} from '@mui/icons-material';
import { toast } from "react-toastify";
import CollapsiblePhase from "./CollapsiblePhase";
import { useProjectPlan, useProjectPlanDispatch } from "./ProjectPlanContext";
import { DurationTypeContext, MeasurementsMenu } from "./EstimationPageUtils";
import { formatSeconds } from "../../util/GlobalFunctions";
import { TIME_FORMAT } from "../../util/Constants";
import { helperDialogs } from "../../util/HelperDialogs";
import Limit from "./Limit";

export default function CollapsibleElement(props: any) {
  //console.log(props);
  const { t } = useTranslation();
  const getHideTree = () => {
    if (props.elements.projectElement.projectPhases.length == 1) {
      if (props.elements.projectElement.projectPhases[0].projectTasks.length == 1) {
        return true;
      }
    }

    return false;
  }
  const hideTree = getHideTree();
  const statisticalRange = useContext(DurationTypeContext);
  const [durationFocused, setDurationFocused] = useState(false);
  const [showPhases, setShowPhases] = useState(false);
  const [nameExists, setNameExists] = useState(false);
  const [duration, setDuration] = useState(
    Math.round(props.elements.projectElement.estimatedDays)
  );

  const [effortFocused, setEffortFocussed] = useState(false);
  const [effort, setEffort] = useState(props.elements.projectElement.estimatedTime);

  useEffect(() => {
    if (duration !== props.elements.projectElement.estimatedDays && !durationFocused) {
      setDuration(Math.round(props.elements.projectElement.estimatedDays))
    }
  }, [props]);

  const [phaseTypes, setPhaseTypes] = useState(
    () => {
      let phasesBySizeAndComplex = getPhaseTypesByComplexity(props.elements.elementType.dificulties,
        props.elements.projectElement.idSize, props.elements.projectElement.idComplexity);
      if (typeof phasesBySizeAndComplex == "undefined") {
        phasesBySizeAndComplex = props.elements.elementType.dificulties[0].phasetypes;
      }
      // Setear phaseTypes de acuerdo a tamaño y coplejidad
      const phases = JSON.parse(JSON.stringify(phasesBySizeAndComplex));
      //console.log("phases", phases);
      return props.elements.projectElement.projectPhases.map(
        (projectPhase: any) =>
          phases.find((phaseType: any) => phaseType.id === projectPhase.idPhaseType)
      );
    }
  );
  const [notAddedPhases, setNotAddedPhases] = useState([]);
  const [createPhase, setCreatePhase] = useState(false);
  const [openMeasurementsMenu, setOpenMeasurementsMenu] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const openOptions = Boolean(anchorEl);

  const projectPlan = useProjectPlan();
  const projectPlanDispatch = useProjectPlanDispatch();

  const adjustedDurationMin = statisticalRange ? props.elements.projectElement.duration_min :
    props.elements.projectElement.projectPhases.reduce((acc: number, phaseType: any) =>
      acc < phaseType.estimatedDays ? phaseType.estimatedDays : acc,
      0
    );
  const adjustedDurationMax = statisticalRange ? props.elements.projectElement.duration_max :
    props.elements.projectElement.projectPhases.reduce(
      (acc: number, phaseType: any) => acc + phaseType.estimatedDays,
      0
    );
  const elementTimeMin = props.elements.projectElement.projectPhases.reduce(
    (acc: number, phase: any) =>
      acc < phase.estimatedDays ? phase.estimatedDays : acc,
    0
  );

  // @ts-ignore
  function getPhaseTypesByComplexity(arrDificulties, size, complexity) {
    for (let i = 0; i < arrDificulties.length; i++) {
      if (arrDificulties[i].size_id == size && arrDificulties[i].complexity_id == complexity) {
        return arrDificulties[i].phasetypes;
      }
    }
  }

  const handleClickOptions = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseOptions = () => {
    setAnchorEl(null);
  };

  const deletePhase = (phaseIndex: number) => {
    const phases = JSON.parse(JSON.stringify(phaseTypes));
    const deletedPhases = JSON.parse(JSON.stringify(notAddedPhases));

    deletedPhases.push(
      phaseTypes[phaseIndex]
    );

    projectPlanDispatch({
      type: 'deletePhase',
      planIndexes: {
        elementTypeIndex: props.indexes.elementTypeIndex,
        projectElementIndex: props.indexes.elementIndex,
        phaseIndex: phaseIndex
      },
      adjustedDuration: !statisticalRange
    });

    phases.splice(phaseIndex, 1);

    setPhaseTypes(phases);

    setNotAddedPhases(deletedPhases);
  }

  const handleElementDelete = () => {
    handleCloseOptions();
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <TrueffortConfirmAlert
            title={
              <Typography color='error' variant='h6' fontWeight={700} marginBottom='20px' >
                <ReportProblemIcon color='error' />&nbsp;&nbsp;{t("Warning")}
              </Typography>
            }
            alertColor='error'
            messages={[
              t("project_page.msg_delete_element_confirm2") + props.elements.projectElement.name + "?",
              t("project_page.msg_delete_element_confirm3")
            ]}
            buttons={[
              {
                label: t("project_page.msg_delete_task_confirm_no"),
                onClick: onClose
              },
              {
                label: t("project_page.msg_delete_task_confirm_yes"),
                onClick: () => {
                  props.deleteElement(props.indexes.elementTypeIndex, props.indexes.elementIndex);
                  onClose();
                }
              }
            ]}
          />
        );
      }
    });
  }

  const handlePhaseDelete = (phaseIndex: number) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <TrueffortConfirmAlert
            title={
              <Typography color='error' variant='h6' fontWeight={700} marginBottom='20px' >
                <ReportProblemIcon color='error' />&nbsp;&nbsp;{t("Warning")}
              </Typography>
            }
            alertColor='error'
            messages={[
              t("project_page.msg_delete_phase_confirm2") + phaseTypes[phaseIndex].name + "?",
              t("project_page.msg_delete_phase_confirm3")
            ]}
            buttons={[
              {
                label: t("project_page.msg_delete_task_confirm_no"),
                onClick: onClose
              },
              {
                label: t("project_page.msg_delete_task_confirm_yes"),
                onClick: () => {
                  deletePhase(phaseIndex);
                  onClose();
                }
              }
            ]}
          />
        );
      }
    });
  }

  const addPhase = (phaseType: any) => {
    const phases = JSON.parse(JSON.stringify(phaseTypes));
    phases.unshift(phaseType);

    projectPlanDispatch({
      type: 'addPhase',
      newPhaseType: phaseType,
      planIndexes: {
        elementTypeIndex: props.indexes.elementTypeIndex,
        projectElementIndex: props.indexes.elementIndex
      },
      adjustedDuration: !statisticalRange
    });

    setPhaseTypes(phases);
    setNotAddedPhases(notAddedPhases.filter((phase: any) => phase.id !== phaseType.id));
  }

  const checkRepeatedName = (name: string) => {
    for (let i = 0; i < projectPlan.elementTypes[props.indexes.elementTypeIndex].projectElements.length; i++) {
      let nombre = projectPlan.elementTypes[props.indexes.elementTypeIndex].projectElements[i].name;
      if (nombre.trim() === name.trim()) {
        setNameExists(true);
        props.setSaveDisabled(true);
        return;
      }
    }
    setNameExists(false);
    props.setSaveDisabled(false);
  }

  const handleElementNameChange = (event: any) => {
    checkRepeatedName(event.target.value);

    projectPlanDispatch({
      type: 'changeElementName',
      newElementName: event.target.value,
      planIndexes: {
        elementTypeIndex: props.indexes.elementTypeIndex,
        projectElementIndex: props.indexes.elementIndex
      }
    });
  }

  const handleElementNotesChange = (event: any) => {

    projectPlanDispatch({
      type: 'changeElementNotes',
      newElementNotes: event.target.value,
      planIndexes: {
        elementTypeIndex: props.indexes.elementTypeIndex,
        projectElementIndex: props.indexes.elementIndex
      }
    });
  }

  const handleElementDurationChange = (timeValue: number) => {
    if (timeValue < elementTimeMin || timeValue < 0 || (!statisticalRange && timeValue > adjustedDurationMax && !hideTree)) {
      setDuration(
        Math.round(props.elements.projectElement.estimatedDays)
      );
      return;
    }

    setDuration(timeValue);
    let planIndexes = hideTree ? {
      elementTypeIndex: props.indexes.elementTypeIndex,
      projectElementIndex: props.indexes.elementIndex,
      phaseIndex: 0,
      taskIndex: 0
    } : {
      elementTypeIndex: props.indexes.elementTypeIndex,
      projectElementIndex: props.indexes.elementIndex
    };

    let level = hideTree ? 3 : 1;

    projectPlanDispatch({
      type: 'changeDuration',
      newDurationValue: timeValue,
      level, planIndexes,
      adjustedDuration: !statisticalRange
    });
  }

  const handleActivityEffortChange = (value: number) => {
    if (value < 0) {
      setEffort(props.elements.projectElement.estimatedTime);
      return;
    }
    setEffort(value);
    projectPlanDispatch({
      type: 'changeEffort',
      newEffortValue: value,
      planIndexes: {
        elementTypeIndex: props.indexes.elementTypeIndex,
        projectElementIndex: props.indexes.elementIndex,
        phaseIndex: 0,
        taskIndex: 0
      }
    });
  }

  const handleMeasurementsChange = (newSize: number, newComplexity: number, newFunctionalSize: number) => {
    const newMeasurements: { newSize?: number, newComplexity?: number, newFunctionalSize?: number } = {};
    if (newSize !== props.elements.projectElement.idSize) {
      newMeasurements.newSize = newSize;
    }
    if (newComplexity !== props.elements.projectElement.idComplexity) {
      newMeasurements.newComplexity = newComplexity;
    }
    if (newFunctionalSize !== props.elements.projectElement.functionalSize) {
      newMeasurements.newFunctionalSize = newFunctionalSize;
    }

    projectPlanDispatch({
      type: 'changeMeasurements',
      newMeasurements: newMeasurements,
      planIndexes: {
        elementTypeIndex: props.indexes.elementTypeIndex,
        projectElementIndex: props.indexes.elementIndex
      }
    });
  }

  const handleDurationBlur = () => {
    if (duration === '') {
      setDuration(Math.round(props.elements.projectElement.estimatedDays));
    } else {
      handleElementDurationChange(Math.round(Number(duration)));
    }

    setDurationFocused(false);
  }

  const handleEffortBlur = () => {
    if (effort === '') {
      //setEffort(Math.round(props.task.projectTask.estimatedTime));
      setEffort(props.task.projectTask.estimatedTime);
    } else {
      //handleActivityEffortChange(Math.round(Number(effort)));
      handleActivityEffortChange(Number(effort));
    }

    setEffortFocussed(false);
  }

  return (
    <>
      <Paper variant="outlined" square sx={{ padding: '10px' }} >
        <Grid container spacing={2} alignItems="center" >
          <Grid item xs={0.5} sx={{ display: 'flex', alignItems: "center", justifyContent: "center" }} >
            {Math.round(props.elements.projectElement.estimatedTime) > 0 &&
              Math.round(props.elements.projectElement.estimatedDays) > 0 ?
              <Typography color='#4A4A4A' >
                {props.numElement}
              </Typography> :

              <Tooltip title={t("estimation_page.cero_values_error")} placement='top'>
                <ErrorIcon color='error' />
              </Tooltip>
            }
          </Grid>
          <Grid item xs={2.5} >
            <Stack direction="row" spacing={5} alignItems="center" justifyContent='space-between' >
              <Typography >
                <IconButton
                  aria-label="expand row"
                  size="small"
                  onClick={() => setShowPhases(!showPhases)}
                >
                  {showPhases ? <ArrowDropDownIcon /> : <ArrowRightIcon />}
                </IconButton>

                {props.elements.elementType.name}
              </Typography>

              {props.detailHelperDialogsConfig !== undefined ?
                <HelperDialog
                  title={t(helperDialogs["estimationDetail"][7].title)}
                  body={t(helperDialogs["estimationDetail"][7].body)}
                  dialogIndex={7}
                  totalDialogs={!projectPlan.elementTypes.length ?
                    helperDialogs["estimationDetail"].length - 2 :
                    helperDialogs["estimationDetail"].length
                  }
                  handleNext={props.detailHelperDialogsConfig.handleActiveDetailHelperChange}
                  isOpen={props.detailHelperDialogsConfig.activeDetailDialogIndex === 7}
                  handleClose={props.detailHelperDialogsConfig.handleDetailHelperClose}
                  position='right'
                >
                  <Chip
                    sx={{ borderRadius: '3px' }}
                    icon={<FontAwesomeIcon icon={faFolderTree} color={'#68C8BA'} />}
                    label={props.elements.projectElement.projectPhases.length + " " + t("home.phases")}
                    variant='outlined'
                  />
                </HelperDialog> :
                <Chip
                  sx={{ borderRadius: '3px' }}
                  icon={<FontAwesomeIcon icon={faFolderTree} color={'#68C8BA'} />}
                  label={props.elements.projectElement.projectPhases.length + " " + t("home.phases")}
                  variant='outlined'
                />
              }
            </Stack>
          </Grid>

          <Grid item xs={3} >
            {props.detailHelperDialogsConfig !== undefined ?
              <HelperDialog
                title={t(helperDialogs["estimationDetail"][8].title)}
                body={t(helperDialogs["estimationDetail"][8].body)}
                dialogIndex={8}
                totalDialogs={helperDialogs["estimationDetail"].length}
                handleNext={props.detailHelperDialogsConfig.handleActiveDetailHelperChange}
                isOpen={props.detailHelperDialogsConfig.activeDetailDialogIndex === 8}
                handleClose={props.detailHelperDialogsConfig.handleDetailHelperClose}
                position='right'
              >
                <TextField
                  id={"element-name-" + props.indexes.elementIndex}
                  size="small"
                  fullWidth
                  value={props.elements.projectElement.name}
                  onChange={handleElementNameChange}
                  error={nameExists}
                //helperText={!formikPhase.errors?.name || !formikPhase.touched?.name ? undefined : t(formikPhase.errors.name)}
                />
              </HelperDialog> :
              <TextField
                id={"element-name-" + props.indexes.elementIndex}
                size="small"
                fullWidth
                value={props.elements.projectElement.name}
                onChange={handleElementNameChange}
                error={nameExists}
              //helperText={!formikPhase.errors?.name || !formikPhase.touched?.name ? undefined : t(formikPhase.errors.name)}
              />
            }
          </Grid>

          <Grid item xs={2} >
            {hideTree ? 
            <Stack direction='row' spacing={1} alignItems='center' justifyContent='center' >
              <Limit
                isMax={false}
                label={props.elements.projectElement.effort_sigma_interval_low}
                total={Math.round(props.elements.projectElement.estimatedTime)}
                estimatedVal={props.elements.projectElement.effort_sigma_interval_low}
                handle={handleActivityEffortChange}
                disabled={false}
              />
              <Stack direction="column" spacing={0} alignItems="center" justifyContent="center" >
                <Typography variant='caption' >
                  {t("estimation_page.avg")}
                </Typography>
                <TextField
                  name="estimatedTime"
                  //sx={{ width: '89px' }}
                  type="number"
                  InputProps={{ inputProps: { min: elementTimeMin } }}
                  size="small"
                  //disabled={!isModifiable || !elementType.active}
                  //onFocus={() => setEffortFocussed(true)}
                  onBlur={handleEffortBlur}
                  value={effort}
                  onChange={(event: any) => handleActivityEffortChange(Number(event.target.value))}
                  onKeyDown={(event: any) => {
                    if (event.key === "Enter") handleActivityEffortChange(Number(event.target.value));
                  }}
                  error={effort <= 0 || props.elements.projectElement.estimatedTime <= 0}
                  //error={effort <= 0 || Math.round(props.elements.projectElement.estimatedTime) <= 0}
                />
              </Stack>
              <Limit
                isMax={true}
                label={props.elements.projectElement.effort_sigma_interval_up}
                total={props.elements.projectElement.estimatedTime}
                estimatedVal={props.elements.projectElement.effort_sigma_interval_up}
                handle={handleActivityEffortChange}
                disabled={false}
              />
            </Stack> :
              <Typography textAlign='center' >
                {
                //formatSeconds(Math.round(props.elements.projectElement.estimatedTime) * 3600, false, false, false) + (localStorage.getItem(TIME_FORMAT) == 'dec' ? " " + t("estimation_page.man_hours") : "")
                formatSeconds(props.elements.projectElement.estimatedTime * 3600, false, false, false) + (localStorage.getItem(TIME_FORMAT) == 'dec' ? " " + t("estimation_page.man_hours") : "")
                }
              </Typography>
            }
          </Grid>

          <Grid item xs={3} >
            <Stack direction='row' spacing={1} alignItems='center' justifyContent='center' >
              <Limit
                title="Min"
                isMax={false}
                label={adjustedDurationMin}
                total={Math.round(props.elements.projectElement.estimatedDays)}
                estimatedVal={adjustedDurationMin}
                handle={handleElementDurationChange}
                disabled={false}
              />
              <Stack direction="column" spacing={0} alignItems="center" justifyContent="center" >
                <Typography variant='caption' >
                  {t("estimation_page.avg")}
                </Typography>
                <TextField
                  name="estimatedDays"
                  //sx={{ width: '89px' }}
                  type="number"
                  InputProps={{ inputProps: { min: elementTimeMin } }}
                  size="small"
                  //disabled={!isModifiable || !elementType.active}
                  onFocus={() => setDurationFocused(true)}
                  onBlur={handleDurationBlur}
                  value={durationFocused ? duration : props.elements.projectElement.estimatedDays}
                  onChange={(event: any) =>
                    durationFocused ? setDuration(event.target.value) :
                      handleElementDurationChange(Math.round(Number(event.target.value)))
                  }
                  onKeyDown={(event: any) => {
                    if (event.key === "Enter")
                      handleElementDurationChange(Math.round(Number(event.target.value)));
                  }}
                  error={duration <= 0 || Math.round(props.elements.projectElement.estimatedDays) <= 0}
                />
              </Stack>
              <Limit
                title="Max"
                isMax={true}
                label={adjustedDurationMax}
                total={Math.round(props.elements.projectElement.estimatedDays)}
                estimatedVal={adjustedDurationMax}
                handle={handleElementDurationChange}
                disabled={false}
              />
            </Stack>
          </Grid>

          <Grid item xs container justifyContent='center' >
            <TrueffortButton
              style={{ maxWidth: '30px', maxHeight: '30px', minWidth: '30px', minHeight: '30px' }}
              size="small"
              color="secondary"
              id="btnOptionsElement"
              aria-controls={openOptions ? 'basic-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={openOptions ? 'true' : undefined}
              onClick={handleClickOptions}
            >
              <PendingIcon />
            </TrueffortButton>

            <Menu
              id="basic-menu"
              sx={{
                '& .MuiPaper-root': {
                  backgroundColor: '#050536'
                }
              }}
              anchorEl={anchorEl}
              open={openOptions}
              onClose={handleCloseOptions}
              MenuListProps={{
                'aria-labelledby': 'basic-button',
              }}
            >
              {JSON.parse(JSON.stringify(notAddedPhases)).length != 0 && <MenuItem
                onClick={() => {
                  handleCloseOptions();
                  setCreatePhase(true);
                }}
              >
                <ListItemIcon>
                  <AddIcon
                    size="small"
                    //className="color-secondary"
                    sx={{ color: '#F5F5F5' }}
                  />
                </ListItemIcon>
                <ListItemText sx={{ color: '#F5F5F5' }}>
                  {t("project_page.add_phase")}
                </ListItemText>
              </MenuItem>}
              <MenuItem
                onClick={() => {
                  handleCloseOptions();
                  setOpenMeasurementsMenu(true);
                }}
              >
                <ListItemIcon>
                  <SquareFootIcon
                    size="small"
                    //className="color-red"
                    sx={{ color: '#F5F5F5' }}
                  />
                </ListItemIcon>
                <ListItemText sx={{ color: '#F5F5F5' }} >
                  {t("estimation_page.measurements")}
                </ListItemText>
              </MenuItem>
              <MenuItem
                onClick={handleElementDelete}
              >
                <ListItemIcon>
                  <DeleteIcon
                    size="small"
                    //className="color-red"
                    sx={{ color: '#989898' }}
                  />
                </ListItemIcon>
                <ListItemText sx={{ color: '#989898' }} >
                  {t("delete")}
                </ListItemText>
              </MenuItem>
            </Menu>
          </Grid>
          <Grid item xs={12} >
            <TextField
              sx={{ background: 'white' }}
              id={"element-notes-" + props.indexes.elementIndex}
              size="small"
              fullWidth
              placeholder={t('project_page.elem_notes_placeholder')}
              labelstring={t('project_page.elem_notes')}
              value={props.elements.projectElement.notes}
              onChange={handleElementNotesChange}
              multiline
              maxRows={2}
            />
          </Grid>
        </Grid>
      </Paper>

      <MeasurementsMenu
        openState={{
          openMenu: openMeasurementsMenu,
          setOpenMenu: setOpenMeasurementsMenu
        }}
        size={props.elements.projectElement.idSize}
        complexity={props.elements.projectElement.idComplexity}
        functionalSize={props.elements.projectElement.functionalSize}
        handleMeasurementsChange={handleMeasurementsChange}
      />

      <Collapse in={showPhases} timeout="auto" unmountOnExit >
        {!hideTree && <Paper variant="outlined" square sx={{ padding: '10px', backgroundColor: '#D7EBF0' }} >
          <Grid container spacing={1} >
            <Grid item xs={0.3} ></Grid>
            <Grid item xs={4} >
              <Typography color={'#27535E'} sx={{ display: 'flex', alignItems: "center" }} >
                <SvgIcon fontSize="small" sx={{ marginRight: '6px' }} >
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11 11" fill="none">
                    <g clipPath="url(#clip0_578_12469)">
                      <path d="M8.93752 7.79167C8.87794 7.79167 8.81835 7.79167 8.75877 7.81L8.02085 6.32042C8.18413 6.16122 8.2962 5.95692 8.3427 5.73367C8.38921 5.51041 8.36804 5.27836 8.2819 5.06721C8.19577 4.85605 8.04859 4.67541 7.8592 4.54838C7.6698 4.42136 7.44682 4.35373 7.21877 4.35417C7.15919 4.35417 7.10419 4.35417 7.04002 4.3725L6.29294 2.88292C6.51294 2.67667 6.64585 2.38792 6.64585 2.0625C6.64585 1.75861 6.52513 1.46716 6.31025 1.25227C6.09536 1.03739 5.80391 0.916667 5.50002 0.916667C5.19613 0.916667 4.90468 1.03739 4.68979 1.25227C4.47491 1.46716 4.35419 1.75861 4.35419 2.0625C4.35419 2.38792 4.4871 2.67667 4.70252 2.88292L3.96002 4.3725C3.89585 4.35417 3.84085 4.35417 3.78127 4.35417C3.55323 4.35373 3.33024 4.42136 3.14084 4.54838C2.95145 4.67541 2.80427 4.85605 2.71814 5.06721C2.632 5.27836 2.61083 5.51041 2.65734 5.73367C2.70384 5.95692 2.81591 6.16122 2.97919 6.32042L2.24127 7.81C2.18169 7.79167 2.1221 7.79167 2.06252 7.79167C1.75863 7.79167 1.46718 7.91239 1.25229 8.12727C1.03741 8.34216 0.916687 8.63361 0.916687 8.9375C0.916687 9.24139 1.03741 9.53284 1.25229 9.74773C1.46718 9.96261 1.75863 10.0833 2.06252 10.0833C2.21299 10.0833 2.36199 10.0537 2.50101 9.99611C2.64003 9.93853 2.76635 9.85413 2.87275 9.74773C2.97915 9.64133 3.06355 9.51501 3.12113 9.37599C3.17872 9.23697 3.20835 9.08797 3.20835 8.9375C3.20835 8.61667 3.07544 8.32333 2.86002 8.11708L3.60252 6.6275C3.66669 6.64583 3.72169 6.64583 3.78127 6.64583C3.84085 6.64583 3.89585 6.64583 3.96002 6.6275L4.7071 8.11708C4.49169 8.32333 4.35419 8.61667 4.35419 8.9375C4.35419 9.24139 4.47491 9.53284 4.68979 9.74773C4.90468 9.96261 5.19613 10.0833 5.50002 10.0833C5.80391 10.0833 6.09536 9.96261 6.31025 9.74773C6.52513 9.53284 6.64585 9.24139 6.64585 8.9375C6.64585 8.63361 6.52513 8.34216 6.31025 8.12727C6.09536 7.91239 5.80391 7.79167 5.50002 7.79167C5.44044 7.79167 5.38085 7.79167 5.32127 7.81L4.58335 6.32042C4.79419 6.11417 4.9271 5.82542 4.9271 5.5C4.9271 5.17458 4.79419 4.88583 4.58335 4.67958L5.32127 3.19C5.38085 3.20833 5.44044 3.20833 5.50002 3.20833C5.5596 3.20833 5.61919 3.20833 5.67877 3.19L6.41669 4.67958C6.21044 4.88583 6.07294 5.17917 6.07294 5.5C6.07294 5.80389 6.19366 6.09534 6.40854 6.31023C6.62343 6.52511 6.91488 6.64583 7.21877 6.64583C7.27835 6.64583 7.33335 6.64583 7.39752 6.6275L8.1446 8.11708C7.92919 8.32333 7.79169 8.61667 7.79169 8.9375C7.79169 9.24139 7.91241 9.53284 8.12729 9.74773C8.34218 9.96261 8.63363 10.0833 8.93752 10.0833C9.24141 10.0833 9.53286 9.96261 9.74775 9.74773C9.96263 9.53284 10.0834 9.24139 10.0834 8.9375C10.0834 8.63361 9.96263 8.34216 9.74775 8.12727C9.53286 7.91239 9.24141 7.79167 8.93752 7.79167Z" fill="#27535E" />
                    </g>
                    <defs>
                      <clipPath id="clip0_578_12469">
                        <rect width="11" height="11" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </SvgIcon>

                {t("home.phases")}
              </Typography>
            </Grid>
            <Grid item xs={3} >
              <Typography variant="subtitle2" textAlign='center' >
                {t("estimation_page.effort_man_hours")}
              </Typography>
            </Grid>
            <Grid item xs={3} >
              <Typography variant="subtitle2" textAlign='center' >
                {t("estimation_page.days_duration")}
              </Typography>
            </Grid>
          </Grid>
        </Paper>
        }

        {createPhase &&
          <AddPhaseForm
            t={t}
            notAddedPhases={JSON.parse(JSON.stringify(notAddedPhases))}
            setCreatePhase={setCreatePhase}
            addPhase={addPhase}
          />
        }

        {props.elements.projectElement.projectPhases.map((phase: any, index: number) => (
          <CollapsiblePhase
            key={
              index + "-" +
              phase.idPhaseType +
              "-" + props.elements.elementType.idElementType +
              "-" + props.elements.projectElement.name
            }
            phase={{
              projectPhase: phase,
              phaseType: phaseTypes[index]
            }}
            handlePhaseDelete={handlePhaseDelete}
            indexes={({ ...props.indexes, phaseIndex: index })}
            hideTree={hideTree}
            plan={props.plan}
            priorityTypes={props.priorityTypes}
          />
        ))}
      </Collapse>
    </>
  );

}

function AddPhaseForm({ t, notAddedPhases, setCreatePhase, addPhase }: any) {
  //console.log(notAddedPhases);
  const statisticalRange = useContext(DurationTypeContext);

  const [idSelectedPhaseType, setIdSelectedPhaseType] = useState('');
  const selectedPhase = (
    idSelectedPhaseType !== '' ?
      notAddedPhases.find((phase: any) => phase.id == idSelectedPhaseType) :
      {
        id: '',
        name: '',
        effort_min: '',
        effort_max: '',
        effort_avg: '',
        duration_avg: '',
        duration_min: '',
        duration_max: '',
      });
  const adjustedDurationMin = idSelectedPhaseType === '' ? undefined :
    statisticalRange ? selectedPhase.duration_min :
      selectedPhase.tasktypes.reduce(
        (acc: number, tasktype: any) =>
          acc < tasktype.duration_avg ? tasktype.duration_avg : acc,
        0
      );
  const adjustedDurationMax = idSelectedPhaseType === '' ? undefined :
    statisticalRange ? selectedPhase.duration_max :
      selectedPhase.tasktypes.reduce(
        (acc: number, tasktype: any) => acc + tasktype.duration_avg,
        0
      );

  const handlePhaseAdd = () => {
    if (selectedPhase.id === '') {
      return;
    }

    addPhase(selectedPhase);

    toast.success(t("estimation_page.phase_added"));
    reset();
  }

  const reset = () => {
    setIdSelectedPhaseType('');
    setCreatePhase(false);
  }

  return (
    <Paper
      variant="outlined"
      square
      sx={{ padding: '10px', backgroundColor: 'rgba(215, 235, 240, 0.30)' }}
    >
      <Grid container spacing={1} alignItems="center" >
        <Grid item xs={0.5} ></Grid>
        <Grid item xs={3} >
          <MaterialSelect
            size='small'
            fullWidth
            displayEmpty
            disabled={!notAddedPhases.length}
            onChange={(event: any) => setIdSelectedPhaseType(event.target.value)}
            value={idSelectedPhaseType}
          >
            <MenuItem
              value=""
              disabled
            >
              {notAddedPhases.length ? t("Select") : t("estimation_page.no_phase")}
            </MenuItem>
            {notAddedPhases.map((phase: any) =>
              <MenuItem
                key={phase.id}
                value={phase.id}
              >
                {phase.name}
              </MenuItem>
            )}
          </MaterialSelect>
        </Grid>

        <Grid item xs={2} >
          <Typography textAlign='center' >
            {selectedPhase.effort_avg + " " + t("estimation_page.man_hours")}
          </Typography>
        </Grid>
        <Grid item xs={2} >
          <Stack direction='row' spacing={1} alignItems='center' justifyContent='center' >
            <Stack direction="column" spacing={0} alignItems="center" justifyContent="center" >
              <Typography variant='caption' >
                Min
              </Typography>

              <TrueffortChip
                icon={
                  <SvgIcon >
                    <svg
                      viewBox="0 0 13 13"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M3.5 10.5L5.5 8.5H4V2.5H3V8.5H1.5L3.5 10.5ZM6 4.5H10.5V5.5H6V4.5ZM6 6.5H9.5V7.5H6V6.5ZM6 2.5H11.5V3.5H6V2.5ZM6 8.5H8.5V9.5H6V8.5Z"
                        fill="#6693CB"
                      />
                    </svg>
                  </SvgIcon>
                }
                size='small'
                color='secondary'
                variant='outlined'
                label={
                  /*selectedPhase.duration_min*/
                  adjustedDurationMin
                }
              />
            </Stack>

            <Stack direction="column" spacing={0} alignItems="center" justifyContent="center" >
              <Typography variant='caption' >
                {t("estimation_page.avg")}
              </Typography>

              <TextField
                name="estimatedDays"
                //sx={{ width: '89px' }}
                size="small"
                disabled
                value={
                  /*selectedPhase.duration_avg*/
                  idSelectedPhaseType === '' ? undefined :
                    statisticalRange ? selectedPhase.duration_avg :
                      Math.round((adjustedDurationMin + adjustedDurationMax) / 2)
                }
              />
            </Stack>

            <Stack direction="column" spacing={0} alignItems="center" justifyContent="center" >
              <Typography variant='caption' >
                Max
              </Typography>

              <TrueffortChip
                icon={
                  /*<FontAwesomeIcon icon={faArrowUpWideShort} color={'#6693CB'} size="2xs" />*/
                  <SvgIcon >
                    <svg
                      width="13"
                      height="13"
                      viewBox="0 0 13 13"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6 4.5H10.5V5.5H6V4.5ZM6 6.5H9.5V7.5H6V6.5ZM6 2.5H11.5V3.5H6V2.5ZM6 8.5H8.5V9.5H6V8.5ZM3 10H4V4H5.5L3.5 2L1.5 4H3V10Z"
                        fill="#6693CB"
                      />
                    </svg>
                  </SvgIcon>
                }
                size='small'
                color='secondary'
                variant='outlined'
                label={
                  /*selectedPhase.duration_max*/
                  adjustedDurationMax
                }
              />
            </Stack>
          </Stack>
        </Grid>

        <Grid item xs container justifyContent="center" >
          <Stack direction="row" spacing={3} >
            <Chip
              size="small"
              icon={<CheckIcon fontSize="small" />}
              label={t("project_page.add_phase")}
              variant="outlined"
              color="success"
              onClick={handlePhaseAdd}
            />

            <Chip
              size="small"
              icon={<CancelIcon fontSize="small" />}
              label={t("Cancel")}
              variant="outlined"
              color='error'
              onClick={reset}
            />
          </Stack>
        </Grid>
      </Grid>
    </Paper>
  );

}
